module.exports = __webpack_public_path__ + "img/list_item_two.f1c822d6.png";